<template>
  <div>
    <a-card v-if="enterpriselist" :bordered="false">
      <a-form layout="inline">
        <div class="table-page-search-wrapper">
          <!--        筛选的条件-->
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="订单号" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.orderNo" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                  <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                    <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                    <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                      type.typeName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                  <a-select v-model="queryParam.orderStatus" :allowClear="true">
                    <a-select-option v-for="type in order_status" :title="type.dictValue" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="客户姓名" style="margin-left: 26px">
                  <a-input v-model.trim="queryParam.clientName" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="客户联系方式">
                  <a-input v-model.trim="queryParam.clientPhone" />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-row :gutter="24" style="margin-left: 0px">
                  <a-form-item label="客户地址" style="margin-left: 26px">
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.clientProvince" @change="getselect" :allowClear="true">
                        <a-select-option
                          v-for="type in selectAllProvince"
                          :title="type.provinceName"
                          :key="type.provinceCode"
                          >{{ type.provinceName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.clientCity" @change="getprovinceName" :allowClear="true">
                        <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :md="5" :sm="24">
                      <a-select v-model="queryParam.clientArea" :allowClear="true">
                        <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :md="9" :sm="24">
                      <a-input v-model.trim="queryParam.clientAddr" />
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="企业名称" style="margin-left: 26px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    :filterOption="filterOption"
                    v-model="queryParam.enterpriseName"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                      >{{ type.enterpriseName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="市场负责人" style="margin-left: 15px">
                  <a-select v-model="queryParam.marketPrincipal" :allowClear="true">
                    <a-select-option v-for="type in marketPrincipal" :title="type.userName" :key="type.userId">{{
                      type.userName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="付款方式" style="margin-left: 26px">
                  <a-select v-model="queryParam.enterprisePayType" :allowClear="true">
                    <a-select-option v-for="type in pay_type" :title="type.dictLabel" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算周期" style="margin-left: 26px">
                  <a-select v-model="queryParam.settlementCycle" :allowClear="true">
                    <a-select-option v-for="type in settle_cycle" :title="type.dictLabel" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="对账单" style="margin-left: 39px">
                  <a-select v-model="queryParam.statementFlag" :allowClear="true">
                    <a-select-option value="1" title="生成"> 生成 </a-select-option>
                    <a-select-option value="0" title="未生成"> 未生成 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="品牌" style="margin-left: 60px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    @change="changeBrandName"
                    :filterOption="filterOption"
                    v-model="queryParam.brand"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectBrand" :title="type.brandName" :key="type.brandId">{{
                      type.brandName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="型号" style="margin-left: 57px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    @change="changeModelName"
                    :filterOption="filterOption"
                    v-model="queryParam.model"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectModel" :title="type.modelName" :key="type.modelId">{{
                      type.modelName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="暂不结算" style="margin-left: 26px">
                  <a-select v-model="queryParam.temporarilySettle" :allowClear="true">
                    <a-select-option value="0" title="否"> 否 </a-select-option>
                    <a-select-option value="1" title="是"> 是 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <div v-if="Ifstatus">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="购买渠道" style="margin-left: 26px">
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      @change="changesourceName"
                      :filterOption="filterOption"
                      v-model="queryParam.channel"
                      :allowClear="true"
                    >
                      <a-select-option v-for="type in selectChannel" :title="type.channelName" :key="type.channelId"
                        >{{ type.channelName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="建单人" style="margin-left: 45px">
                    <a-input v-model.trim="queryParam.createUser" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单负责人" style="margin-left: 13px">
                    <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                      <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                        type.userName
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单子状态" style="margin-left: 13px">
                    <a-select v-model="queryParam.orderSubStatus" :allowClear="true">
                      <a-select-option v-for="type in order_substate" :title="type.dictLabel" :key="type.dictValue">{{
                        type.dictLabel
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="备注" style="margin-left: 55px">
                    <a-input v-model.trim="queryParam.remark" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单完成时间">
                    <a-range-picker
                      v-model="orderFinish"
                      style="width: 100%"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangecompleteOrder"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="建单时间" style="margin-left: 26px">
                    <a-range-picker
                      v-model="createTime"
                      style="width: 100%"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangecreateOrde"
                    />
                  </a-form-item>
                </a-col>

                <a-col :md="6" :sm="24">
                  <a-form-item label="对账单编号" style="margin-left: 15px">
                    <a-input v-model.trim="queryParam.statementNo" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <!--        查询和清空按钮-->
          </a-form>
        </div>
        <a-row>
          <a-col :span="1" :offset="11">
            <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
              ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
            /></span>
            <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
              ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
            /></span>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'right' }">
            <a-button type="primary" htmlType="submit" @click="query()">查询</a-button>
            <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
            <a-button style="margin-left: 8px" type="primary" v-if="exportEnterpriseBill" @click="exportEnt()"
              >导出 Excel</a-button
            >
          </a-col>
        </a-row>
        <a-divider />
        <a-row>
          <a-col :span="10"></a-col>
          <a-col :span="8"> </a-col>
          <a-col :span="6" :style="{ textAlign: 'right' }" style="margin-right: 0px">
            <div style="margin-bottom: 16px; margin-right: 0px">
              <a-button
                v-if="generateEnterpriseBill"
                type="primary"
                @click="goEnterpriseStatement()"
                :loading="loading"
                style="margin-right: 0px"
              >
                生成对账单
              </a-button>
              <span>
                <template v-if="hasSelected">
                  {{ `选中 ${selectedRowKeys.length} 条对账单` }}
                </template>
              </span>
            </div>
          </a-col>
        </a-row>
        <!--</div>-->
        <!--    生成对账单的按钮和方法-->

        <!--    表格内容-->
        <s-table
          style="margin-top: 24px"
          size="default"
          ref="table"
          rowKey="orderId"
          :columns="columns"
          :data="loadData"
          bordered
          :scroll="{ x: 3800 }"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <span slot="remark" slot-scope="text, record">
            <span v-if="record.remark">
              <span v-for="tab in record.remark.split('/$/,')">
                <span>
                  {{ tab }}
                </span>
                <br />
              </span>
            </span>
          </span>
          <span slot="action" slot-scope="text, record" style="white-space: nowrap">
            <a v-if="seeEnterpriseBill" @click="orderdetailsView(record.orderId)">查看</a>
            <a-divider
              type="vertical"
              v-if="(remarkEnterpriseBill && seeEnterpriseBill) || (seeEnterpriseBill && generateEnterpriseBill)"
            />
            <a v-if="remarkEnterpriseBill" @click="remarkList(record)">备注</a>
            <a-divider type="vertical" v-if="generateEnterpriseBill && record.statementFlagCode == 0" />
            <a v-if="generateEnterpriseBill && record.statementFlagCode == 0" @click="goEnterpriseOne(record)"
              >生成对账单</a
            >
          </span>
          <span slot="orderNo" slot-scope="text, record">
            <a-popover title="订单备注">
              <template slot="content">
                <span v-if="record.remark">
                  <span v-for="tab in record.remark.split('/$/,')"
                    ><span>{{ tab }}</span>
                    <br />
                  </span>
                </span>
              </template>
              <a type="primary">
                {{ record.orderNo }}
              </a>
            </a-popover>
          </span>
          <span slot="totalPrice" slot-scope="text, record">
            <a-popover title="企业费用明细">
              <template slot="content">
                <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-if="record.amountDetail">
                  <span v-for="tab in record.amountDetail.split('/$/')"
                    ><span>{{ tab }}</span>
                    <br />
                  </span>
                </div>
              </template>
              <a type="primary">
                {{ record.totalPrice }}
              </a>
            </a-popover>
          </span>
        </s-table>
      </a-form>

      <!-- 使用弹框组件-->
      <a-modal :title="Toptitle" style="top: 20px" width="75%" v-model="generateible" footer="">
        <a-table
          size="default"
          rowKey="sourceId"
          :columns="generatecolumns"
          :dataSource="DataList"
          :scroll="{ x: 1300 }"
          bordered
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record" style="white-space: nowrap">
            <a @click="billingView(record)">查看</a>
            <a-divider type="vertical" />
            <a @click="modifyDefaultTemplate(record)">修改默认模板</a>
            <a-divider type="vertical" />
            <a @click="remarkList(record)">备注</a>
            <a-divider type="vertical" />
            <a @click="remove(record)">移除</a>
          </span>
        </a-table>
        <div style="margin-bottom: 16px">
          <a-button
            type="primary"
            @click="EnterpriseStatementConfirm()"
            :loading="loading"
            style="margin-right: 20px; margin-top: 20px"
          >
            生成对账单
          </a-button>
          <a-button
            type="primary"
            @click="goEnterpriseBill()"
            :loading="loading"
            style="margin-right: 20px; margin-top: 20px"
          >
            取消
          </a-button>
        </div>
      </a-modal>
      <!--    移除对账单确定按钮-->
      <a-modal
        title="移除"
        style="top: 20px"
        :width="800"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <p>确定移除该条对账单吗？</p>
      </a-modal>
      <!--    生成对账单确定按钮-->
      <!--<a-modal title="生成企业对账单"-->
      <!--v-model="Enterprisevisible"-->
      <!--@ok="EnterpriseOk"-->
      <!--:confirmLoading="confirmLoading"-->
      <!--@cancel="handleCancel"-->
      <!--cancelText="返回"-->
      <!--okText="确认且进入对账单"-->

      <!--&gt;-->
      <!--<p>对账单已生成，是否进入对账单列表？</p>-->
      <!--</a-modal>-->
      <a-modal
        title="查看账单信息"
        style="top: 20px"
        :width="1600"
        v-model="informationible"
        @click="clicInformationModal"
        footer=""
      >
        <a-form :form="form">
          <a-table
            size="default"
            rowKey="sourceId"
            :columns="informationcolumns"
            :dataSource="billinglist"
            bordered
            :pagination="false"
            :scroll="{ x: 3000 }"
          >
            <span slot="remark" slot-scope="text, record">
              <span v-if="record.remark">
                <span v-for="tab in record.remark.split('/$/,')">
                  <span>
                    {{ tab }}
                  </span>
                  <br />
                </span>
              </span>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a @click="orderNodetailsView(record.orderId)">{{ record.orderNo }}</a>
            </span>
          </a-table>
        </a-form>
      </a-modal>
      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkgenerateible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item style="display: none">
            <a-input v-decorator="['enterpriseId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item style="display: none">
            <a-input v-decorator="['enterpriseId']" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <modify-default-template-model ref="modify"></modify-default-template-model>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
      <associated-order-model ref="associatedorder" @ok="updateFeedbacklist"></associated-order-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>
import NoAuthority from '../enterprise/NoAuthority'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import associatedOrderModel from '@/views/order/modules/associatedOrderModel'
import { STable } from '@/components'
import { getTemplate } from '@/api/finance/customerSingle'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
  getfinddictAll
} from '@/api/order/orderList'
import { getselectCombox, getselectSource, getselectChannel } from '@/api/order/NewlyaddedOrderList'
import {
  getSourceList,
  getEnterpriseList,
  getremarkList,
  saveremarkList,
  getenterGenerateState,
  getexportList
} from '@/api/finance/enterpriseBill'

import EnterpriseModal from './modules/EnterpriseModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import pick from 'lodash.pick'
import modifyDefaultTemplateModel from './modules/modifyDefaultTemplateModel.vue'
import ACol from 'ant-design-vue/es/grid/Col'
export default {
  name: 'EnterpriseBill',
  components: {
    ACol,
    STable,
    modifyDefaultTemplateModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    associatedOrderModel,
    NoAuthority
  },
  data() {
    return {
      DataList: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      Toptitle: '',
      remarkible: false,
      remarkgenerateible: false,
      informationible: false,
      Ifstatus: 0,
      findByDeptId: [],
      selectSource: [],
      selectChannel: [],
      selectCombox: [],
      selectBrand: [],
      selectModel: [],
      marketPrincipal: [],

      order_substate: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      List: [],

      selectedRowKeys: [],
      generatecolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '订单总计',
          dataIndex: 'orderAmount',
          align: 'center'
        },
        {
          title: '账单截止日期',
          dataIndex: 'closingDate',
          align: 'center'
        },
        {
          title: '付款方式',
          dataIndex: 'payMethod',
          align: 'center'
        },
        {
          title: '结算周期',
          dataIndex: 'settleCycle',
          align: 'center'
        },
        {
          title: '回款方式',
          dataIndex: 'returnMoneyMethod',
          align: 'center'
        },
        {
          title: '回款日',
          dataIndex: 'returnMoneyDay',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ],
      selectedRow: [], // Check here to configure the default column
      loading: false,
      generateible: false,
      removeible: false,
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 字典为订单状态,
      order_status: [],
      orderid: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '付款方式',
          dataIndex: 'enterprisePayType',
          align: 'center'
        },
        {
          title: '结算周期',
          dataIndex: 'settlementCycle',
          align: 'center'
        },
        {
          title: '状态栏',
          dataIndex: 'majorOrderFlag',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center'
        },

        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px'
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',
          scopedSlots: { customRender: 'totalPrice' },
          align: 'center'
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center'
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center'
        },
        {
          title: '成本',
          dataIndex: 'cost',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center'
        },
        {
          title: '品牌',
          dataIndex: 'brandName',
          align: 'center'
        },
        {
          title: '型号',
          dataIndex: 'modelName',
          align: 'center'
        },
        {
          title: '购买渠道',
          dataIndex: 'channelName',
          align: 'center'
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center'
        },
        {
          title: '暂不结算',
          dataIndex: 'temporarilySettle',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center'
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '350px',
          scopedSlots: { customRender: 'remark' }
        }
      ],
      informationcolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '付款方式',
          dataIndex: 'enterprisePayType',
          align: 'center'
        },
        {
          title: '结算周期',
          dataIndex: 'settlementCycle',
          align: 'center'
        },
        {
          title: '状态栏',
          dataIndex: 'majorOrderFlag',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center'
        },

        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px'
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',

          align: 'center'
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center'
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center'
        },
        {
          title: '成本',
          dataIndex: 'cost',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center'
        },
        {
          title: '品牌',
          dataIndex: 'brandName',
          align: 'center'
        },
        {
          title: '型号',
          dataIndex: 'modelName',
          align: 'center'
        },
        {
          title: '购买渠道',
          dataIndex: 'channelName',
          align: 'center'
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center'
        },
        {
          title: '暂不结算',
          dataIndex: 'temporarilySettle',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center'
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '380px',
          scopedSlots: { customRender: 'remark' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      // 存选中的id
      orderIdArr: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // post的返回值
      reslist: '',
      // Enterprisevisible:false,
      loadData: parameter => {
        return getSourceList(Object.assign(parameter, this.queryParam))
      },
      data: [],
      // 字典为是否
      restaurantTypes: [],
      sys_yes_no: [],
      pay_type: [],
      settle_cycle: [],
      // 字典为安装类型
      installTypes: [],
      generateEnterpriseBill: checkPermission('GenerateEnterpriseBill'),
      remarkEnterpriseBill: checkPermission('remarkEnterpriseBill'),
      exportEnterpriseBill: checkPermission('exportEnterpriseBill'),
      seeEnterpriseBill: checkPermission('seeEnterpriseBill'),
      enterpriselist: checkPermission('enterprise:enterpriseAccount:query:list'),
      recordorderId: '',
      remarkrows: [],
      remarkrecord: '',
      billingrecord: '',
      billinglist: [],
      orderFinish: '',
      createTime: ''
    }
  },
  filters: {},

  // 下拉框的选项
  async created() {
    let dictTypes = ['install_type', 'order_status', 'sys_yes_no', 'pay_type', 'settle_cycle', 'order_substate']
    getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
      this.installTypes = res.install_type
      this.order_status = res.order_status
      this.order_substate = res.order_substate
      this.settle_cycle = res.settle_cycle
      this.pay_type = res.pay_type
      this.sys_yes_no = res.sys_yes_no
    })

    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then(res => {
      this.findByDeptId = res
    })

    this.selectChannel = []
    // 查询信息来源下拉框
    await getselectChannel().then(res => {
      if (res.code === 0) {
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectSource = []
    // 查询信息来源下拉框
    await getselectSource().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectSource = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectBrand = []
    await getSelectBrand().then(res => {
      if (res.code === 0) {
        this.selectBrand = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectModel = []
    await getSelectModel().then(res => {
      if (res.code === 0) {
        this.selectModel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    // 订单负责人
    this.marketPrincipal = []
    await getmarketPrincipal().then(res => {
      this.marketPrincipal = res
    })
    // 企业名称
    this.selectCombox = []
    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.selectCombox = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  // 计算选中的数据条数
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    }
  },
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    query() {
      this.$refs.table.refresh(true)
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    empty() {
      this.queryParam = {}
      this.orderFinish = ''
      this.createTime = ''
    },
    moment,
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    // 修改默认模板
    modifyDefaultTemplate(record) {
      // console.log(record)
      getTemplate({ enterpriseId: record.enterpriseId }).then(res => {
        if (res.code === 0) {
          console.log(res.data)
          this.$refs.modify.showmodify(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportEnt() {
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/enterpriseBill/export?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      // parent.location.href = getVUE_APP_GATEWAR_BASE_URL1()+"/api/apartment/callManage/exportCallManage?"+'attendanceTimestr='+this.queryParam.attendanceTimestr+'&callType='+this.queryParam.callType+'&checkInStatus='+this.queryParam.checkInStatus+'&name='+this.queryParam.name
      // getexportList(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_企业账单'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    clicInformationModal() {
      this.informationible = false
    },
    billingView(record) {
      console.log(record)
      this.billingrecord = record
      this.informationible = true
      getSourceList({ orderIds: record.orderIds.join(',') }).then(res => {
        if (res.code === 0) {
          this.billinglist = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkList(record) {
      this.form.resetFields()
      this.remarkrows = []
      this.remarkrecord = ''
      this.recordorderId = ''

      if (record.enterpriseId) {
        this.remarkrecord = record
        this.remarkible = true
      } else {
        this.remarkgenerateible = true
        this.recordorderId = record.orderId
        getremarkList({ billRemarkType: 1, orderId: record.orderId }).then(res => {
          if (res.code === 0) {
            this.remarkrows = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.remarkgenerateible = false
      if (this.recordorderId) {
        this.form.validateFields((err, values) => {
          values.billRemarkType = 1
          values.orderId = this.recordorderId
          if (!err) {
            saveremarkList(values).then(res => {
              if (res.code === 0) {
                this.$refs.table.refresh()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else {
        let Sub = this.reslist.subStatementDtos.indexOf(this.remarkrecord)
        if (Sub !== -1) {
          //当没有多余tab时就不再删除
          this.reslist.subStatementDtos[Sub].remark = this.form.getFieldValue('remark')
        }
      }
    },
    orderNodetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.associatedorder.showeditOrder(orderId, '', 0)
      })
    },
    orderdetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(orderId, '', 0)
      })
    },
    EnterpriseStatementConfirm() {
      if (this.DataList) {
        this.loading = true
        if (this.DataList.length > 0) {
          // this.Enterprisevisible=true
          this.generateible = false
          let obj = {
            orderNum: this.reslist.orderNum,
            statementNum: this.reslist.statementNum,
            subStatementDtos: this.DataList
          }
          getenterGenerateState(obj).then(res => {
            if (res.code === 0) {
              // console.log(res)
              this.loading = false
              this.query()
              this.$router.push({ name: 'enterpriseStatement' })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('无账单可生成')
        }
      } else {
        this.$message.error('无账单可生成')
      }
    },
    goEnterpriseBill() {
      this.generateible = false
    },
    // 确定生成对账单时时调用的方法
    // EnterpriseOk(){
    //   // this.Enterprisevisible = false;
    //   this.generateible = false;
    //   let obj={
    //     orderNum:this.reslist.orderNum,
    //     statementNum:this.reslist.statementNum,
    //     subStatementDtos: this.DataList,
    //   }
    //   getenterGenerateState(obj).then(res=>{
    //     if (res.code===0){
    //       // console.log(res)
    //       this.$router.push({name:'enterpriseStatement'})
    //     }else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // },
    // 取消时调用的方法
    handleCancel() {
      // this.Enterprisevisible = false;
      this.generateible = false
      // this.$router.push({name:'EnterpriseBill'})
    },
    // 移除
    remove(record) {
      this.removeible = true
      this.orderid.push(record.enterpriseId)
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
      this.orderid = []
    },
    // 移除确定时调用的方法
    confirmOk() {
      this.removeible = false
      this.DataList = this.DataList.filter(item => !this.orderid.includes(item.enterpriseId))
      this.Toptitle = '本次选择' + this.reslist.orderNum + '个订单，共生成' + this.reslist.statementNum + '个对账单：'
    },
    onChangecreateOrde(date, dateString) {
      this.queryParam.createTimeBegin = dateString[0]
      this.queryParam.createTimeEnd = dateString[1]
    },
    onChangecompleteOrder(date, dateString) {
      this.queryParam.orderFinishTimeBegin = dateString[0]
      this.queryParam.orderFinishTimeEnd = dateString[1]
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 点按钮生成对账单
    goEnterpriseStatement() {
      console.log(this.$refs.table.localDataSource)
      if (this.$refs.table.localDataSource.length > 0) {
        // 有选中的值传id
        this.orderIdArr = []
        this.reslist = {}

        // 有选中的值传id
        if (this.selectedRowKeys.length > 0) {
          this.selectedRow.forEach(item => {
            return this.orderIdArr.push(item.orderId)
          })
          getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then(res => {
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          // 没有选中的值传筛选信息
          getEnterpriseList({ isAll: 1, searchParam: this.queryParam }).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else {
        this.$message.error('无账单生成')
      }
    },
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    },
    // 点操作栏生成对账单
    goEnterpriseOne(record) {
      this.reslist = {}
      this.orderIdArr = []
      this.orderIdArr.push(record.orderId)
      getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then(res => {
        if (res.code === 0) {
          this.generateible = true
          this.reslist = res.data
          this.DataList = this.reslist.subStatementDtos
          this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onSelectChange(selectedRowKeys, selectedRow) {
      this.selectedRow = selectedRow
      this.selectedRowKeys = selectedRowKeys
    }
  },
  watch: {}
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/.content .table-operator button {
  margin-right: 0px;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
